import React, { useState } from 'react'
import { AgreementPageHeaderSecondLineProps } from './AgreementPageHeaderSecondLine.types'
import styles from './AgreementPageHeaderSecondLine.module.scss'
import cl from 'classnames'
import { observer } from 'mobx-react-lite'
import { inject } from 'mobx-react'
import { AGREEMENT_PAGE_STORE } from 'store'
import { Button } from 'components/shared'
import { AgreementPreviousVersions } from './AgreementPreviousVersions'
import { IconChanges } from 'assets'
import { VersionChangesList } from './VersionChangesList'

const AgreementPageHeaderSecondLineComponent = (props: AgreementPageHeaderSecondLineProps) => {
  const {
    className,
    style,
    [AGREEMENT_PAGE_STORE]: {
      hasPrevVersions,
      changesCount,
      isAgreementPendingApproval
    }
  } = props

  const [showChanges, setShowChanges] = useState<boolean>(false)
  const [showVersions, setShowVersions] = useState<boolean>(false)

  if (!isAgreementPendingApproval) return null

  return (
    <div
      className={cl(styles.container, className)}
      style={style}
    >
      <Button
        preset='link'
        disabled={!hasPrevVersions}
        onClick={() => setShowVersions(s => !s)}
        className={styles.changesButton}
        onMouseEnter={() => setShowChanges(true)}
        onMouseLeave={() => setShowChanges(false)}
      >
        <IconChanges />
        Changes ({changesCount})
        {showChanges && (
          <VersionChangesList />
        )}
      </Button>

      <Button
        preset='link'
        disabled={!hasPrevVersions}
        onClick={() => setShowVersions(s => !s)}
        className={styles.versionsButton}
      >
        Show versions
      </Button>

      {showVersions && (
        <AgreementPreviousVersions
          closeWindow={() => setShowVersions(false)}
        />
      )}
    </div>
  )
}

const AgreementPageHeaderSecondLine = inject(
  AGREEMENT_PAGE_STORE
)(observer(AgreementPageHeaderSecondLineComponent))
export { AgreementPageHeaderSecondLine }
